import React from 'react'
import Jahazi from '../../assets/jahazi.jpg'
import ViaLogo from '../../assets/via.jpg'
import RetailPhoto from '../../assets/retail.jpg'
import Fafoco from '../../assets/fafoco.jpg'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { FaIcons, FaLocationArrow, FaRegEye, FaRegImages, FaCompass, FaFileLines } from "react-icons/fa6";

const Featured = () => {
    // Parent container variants to control the children
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Delay between each card's animation
            }
        }
    };

    // Individual card variants
    const cardVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: { duration: 2, ease: "easeOut" } 
        }
    };

    return (
        <section className="featured">
            <div className="overlay">
                <div className="container h">
                    <div className="space"></div>
                    <div className="space"></div>
                    <h2 className="h2-light center">Real-world results in the field, the warehouse, and on the screen</h2>
                    <div className="space"></div>
                    
                    {/* The motion.div here controls the staggering of the cards inside it */}
                    <motion.div 
                        className="cards"
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false, amount: 0.1 }}
                    >
                        {/* Card 1 */}
                        <motion.div className="card" variants={cardVariants}>
                            <div className="wrapper">
                                <h3 className="card-head-primary">Digital Hub Architect</h3>
                                <div className="card-image-container">
                                    <img src={ViaLogo} alt="Via Platform" className="card-image" />
                                    <div className="description">
                                        <p className="card-text-dark">
                                            Architecting and designing the Via Platform as a comprehensive 
                                            digital resource hub for refugees and asylum seekers' career transitions
                                        </p>
                                    </div>
                                    <div className="btns-center">
                                        <button className="btn secondary">
                                            <Link to='https://theviaplatform.vercel.app/' target='_blank' rel="noopener">
                                                Explore {' '} <FaLocationArrow className='setting' />
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Card 2 */}
                        <motion.div className="card" variants={cardVariants}>
                            <div className="wrapper">
                                <h3 className="card-head-primary">Electrical Technical Intern</h3>
                                <div className="card-image-container">
                                    <img src={Jahazi} alt="Jahazi Tech" className="card-image" />
                                    <div className="description">
                                        <p className="card-text-dark">
                                            Executing precise maintenance and repair at Jahazi Tech 
                                            for various complex and modern electrical systems, appliances and water pumps
                                        </p>
                                    </div>
                                    <div className="btns-center">
                                        <button className="btn secondary">
                                            <Link to='https://jahazitechelectricals.co.ke/#projects' target='_blank' rel="noopener">
                                                View {' '} <FaRegEye className='setting' />
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Card 3 */}
                        <motion.div className="card" variants={cardVariants}>
                            <div className="wrapper">
                                <h3 className="card-head-primary">Retail Shop Assistant</h3>
                                <div className="card-image-container">
                                    <img src={RetailPhoto} alt="Pick n Pay" className="card-image" />
                                    <div className="description">
                                        <p className="card-text-dark">
                                            Maintaining high service standards at Pick ’n Pay within 
                                            a fast-paced, demanding, high-volume and commercial environment
                                        </p>
                                    </div>
                                    <div className="btns-center">
                                        <button className="btn secondary">
                                            <Link to='https://theviaplatform.vercel.app/' target='_blank' rel="noopener">
                                                Details {' '} <FaFileLines className='setting' />
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Card 4 */}
                        <motion.div className="card" variants={cardVariants}>
                            <div className="wrapper">
                                <h3 className="card-head-primary">Graphic Design Lead</h3>
                                <div className="card-image-container">
                                    <img src={Fafoco} alt="Amazing Food Company" className="card-image" />
                                    <div className="description">
                                        <p className="card-text-dark">
                                            Designing the brand identity for Amazing Food Company while delivering 
                                            quality service and consistent professional standards
                                        </p>
                                    </div>
                                    <div className="btns-center">
                                        <button className="btn secondary">
                                            <Link to='https://www.amazingfoodcompany.com/' target='_blank' rel="noopener">
                                                Discover {' '} <FaCompass className='setting' />
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Card 5 */}
                        <motion.div className="card" variants={cardVariants}>
                            <div className="wrapper">
                                <h3 className="card-head-primary">Assistant Residential Plumber</h3>
                                <div className="card-image-container">
                                    <img src={Jahazi} alt="Plumbing Solutions" className="card-image" />
                                    <div className="description">
                                        <p className="card-text-dark">
                                            Installing and repair technical systems at Plumbing Solutions and managing specialized equipment for various residential building projects
                                        </p>
                                    </div>
                                    <div className="btns-center">
                                        <button className="btn secondary">
                                            <Link to='/gallery'>
                                                Gallery {' '} <FaRegImages className='setting' />
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                </div>
                
                <div className="btns-2 m-2">
                    <button className="light btn">
                        <Link to='/portfolio'>
                            Explore My Work {' '} <FaIcons className='setting'/>
                        </Link>
                    </button>
                </div>
            </div>
        </section>
    )
}

export default Featured